export const getAlert = (state) => state.alert